<template>
  <div>
    <a-form layout="inline" :model="formState" style="margin-bottom: 10px">
      <a-form-item label="角色">
        <a-input
          v-model:value="formState.name"
          placeholder="输入检索角色"
          allow-clear
        />
      </a-form-item>
      <a-form-item label="状态">
        <a-radio-group v-model:value="formState.status">
          <a-radio-button value="">不限</a-radio-button>
          <a-radio-button :value="1">启用</a-radio-button>
          <a-radio-button :value="0">禁用</a-radio-button>
        </a-radio-group>
      </a-form-item>

      <a-form-item>
        <a-button type="primary" @click="handelSearch" v-if="ableSearch">查询</a-button>
      </a-form-item>
      <a-form-item style="position: absolute; right: 30px" v-if="ableAdd">
        <a-button type="primary" @click="showAddModal">添加角色</a-button>
      </a-form-item>
    </a-form>
    <a-modal
      v-model:open="open"
      :title="isEdit ? '编辑角色' : '添加角色'"
      :footer="null"
      :destroyOnClose="true"
    >
      <add-role
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
      ></add-role>
    </a-modal>
    <a-modal
      v-model:open="permOpen"
      title="权限绑定"
      :footer="null"
      :destroyOnClose="true"
    >
      <bind-perm
        @bind="bindOk"
        :isEdit="isEdit"
        :editData="editData"
      ></bind-perm>
    </a-modal>
    <a-modal
      v-model:open="userOpen"
      title="绑定用户"
      :footer="null"
      :destroyOnClose="true"
    >
      <bind-user @submit="bindUserOk" :editData="editData"></bind-user>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'status'">
          {{ record.status ? '启用' : '禁用' }}
        </template>
        <template v-else-if="column.key === 'action'">
          <span>
            <a-button @click="showEditModal(record)" v-if="ableEdit">编辑</a-button>
            <a-button @click="showPermModal(record)" v-if="ableBindPerm">权限</a-button>
            <a-button @click="showUserModal(record)">绑定用户</a-button>
            <a-popconfirm
              title="确认删除？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delRow(record)"
              v-if="ableDelete"
            >
              <a-button danger>删除</a-button>
            </a-popconfirm>
          </span>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, reactive, onMounted, computed } from 'vue'
  import { useStore } from 'vuex'
  import { getRole, deleteRole } from '@/api/system_manage/role'
  import AddRole from './addRole'
  import BindPerm from './bindPerm'
  import BindUser from './bindUser'
  import { message } from 'ant-design-vue'
  const store = useStore()

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'role:list')
  )
  const ableAdd = computed(() =>
    !!permissionList.value?.find(item => item.code === 'role:add')
  )
  const ableEdit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'role:edit')
  )
  const ableDelete = computed(() =>
    !!permissionList.value?.find(item => item.code === 'role:delete')
  )
  const ableBindPerm = computed(() =>
    !!permissionList.value?.find(item => item.code === 'role:bindPerm')
  )

  //1、检索
  const formState = reactive({
    name: '',
    status: '',
  })
  function handelSearch() {
    pagination.value.current = 1
    fetch()
  }

  //2、表格
  const columns = [
    {
      title: '角色',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
    },
    {
      title: '编码',
      dataIndex: 'code',
      key: 'code',
      align: 'left',
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
      align: 'left',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
    },
  ]
  const tableData = ref([])
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })
  const loading = ref(false)
  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }
  function fetch() {
    loading.value = true
    getRole({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      pagination.value.total = data.total
      loading.value = false
      tableData.value = data
    })
  }
  onMounted(fetch)

  //3、添加、编辑
  const open = ref(false)
  const isEdit = ref(false)
  const editData = ref(null)
  const showAddModal = () => {
    editData.value = null
    isEdit.value = false
    open.value = true
  }
  const showEditModal = (data) => {
    editData.value = data
    isEdit.value = true
    open.value = true
  }
  const handleOk = () => {
    open.value = false
    permOpen.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }
  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  //4、绑定权限
  const permOpen = ref(false)
  const showPermModal = (data) => {
    editData.value = data
    permOpen.value = true
  }
  function bindOk() {
    handleOk()
    clearEditData()
  }

  //5、绑定用户
  const userOpen = ref(false)
  const showUserModal = (data) => {
    editData.value = data
    userOpen.value = true
  }
  function bindUserOk() {
    userOpen.value = false
    clearEditData()
  }

  //6、删除
  async function delRow(data) {
    const res = await deleteRole({ roleId: data.role_id })
    if (res.success) {
      message.success('删除成功！')
      fetch()
    } else {
      message.warn('删除失败' + res.message)
    }
  }
</script>
